import React from 'react'
import Link from '../Link'
import Img from 'gatsby-image'
import get from 'lodash/get'

import { Paragraph } from '../Contents'
import ReadMoreButton from '../ReadMoreButton'

import { Cell, ResponsiveContainer } from '../ResponsiveGrid'

import './styles.scss'

const renderBlogPostImage = (props) => (
	get(props.post, 'featured.resolutions', null) !== null ? <Cell colSpanDesktop="2" colSpanTablet="2" colSpanMobile="4" key="image">
		<Link to={`/blog/${props.post.category.slug}/${props.post.slug}`}>
			<Img resolutions={ get(props.post, 'featured.resolutions') } />
		</Link>
	</Cell> : null
)

const renderBlogPostText = (props) => (
	<Cell colSpanDesktop="4" colSpanTablet="2" colSpanMobile="4" withPadding key="text">
		<Link to={`/blog/${props.post.category.slug}/${props.post.slug}`}>
	    	<h3>{ props.post.title }</h3>
	    </Link>
	    <Paragraph text={get(props.post, 'childContentfulBlogPostContentTextNode.childMarkdownRemark.excerpt', null)} />
	    <ReadMoreButton to={`/blog/${props.post.category.slug}/${props.post.slug}`}>
	    	Lire la suite...
	    </ReadMoreButton>
    </Cell>
)

const BlogPostExcerpt = (props) => (<ResponsiveContainer className="Atrakeur-BlogPostExcerpt" white withMarginHor={!props.disableMarginHor} withMarginVer={!props.disableMarginVer} key={props.post.slug}>
	{ 'inverted' in props && props.inverted ? [
		renderBlogPostText(props),
		renderBlogPostImage(props)
	 ]: [
		renderBlogPostImage(props),
		renderBlogPostText(props)
	]}
</ResponsiveContainer>)

export default BlogPostExcerpt




// WEBPACK FOOTER //
// ./src/components/BlogPostExcerpt/index.js